import React from 'react';
import './breadcrumb.css';
const Breadcrumb = () => {
    return (
      <div className="breadcrumb-container">
        <div className="breadcrumb">
          <h2>Book A Call</h2>
        </div>
      </div>
    );
  };
  
  export default Breadcrumb;